import { Deserializable } from '../protocols/deserializable';
import { HistoryItem } from '../../interfaces/history-item';

export class SubmissionHistoryItem implements Deserializable, HistoryItem {
  public id!: string;
  public memberSubmissionId!: string;
  public event!: string;
  public eventDate!: string;

  onDeserialize() {}
}
